import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import ScrapingTasks from './pages/ScrapingTasks';
import TaskResults from './pages/TaskResults';
import MarketplaceDefinitions from './pages/MarketplaceDefinitions';
import DefinitionEditor from './pages/DefinitionEditor';
import SystemStatus from './pages/SystemStatus';
import { Settings } from './pages/Settings';
import Login from './pages/Login';
import Reviews from './pages/Reviews';
import Issues from './pages/Issues';
import DefinitionTestSuites from './pages/DefinitionTestSuites';
import DefinitionTestSuiteReport from './pages/DefinitionTestSuiteReport';
import { useAuth } from './contexts/AuthContext';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <div />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <Box sx={{ display: 'flex' }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Allow MSAL redirect to complete without auth guard */}
        <Route path="/auth/azure/callback" element={<div>Signing in...</div>} />
        {/* Normalize /auth/azure to the app root once authenticated */}
        <Route path="/auth/azure" element={<Navigate to="/" replace />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/tasks" element={<ScrapingTasks />} />
                  <Route path="/tasks/:taskId/results" element={<TaskResults />} />
                  <Route path="/test-suites" element={<DefinitionTestSuites />} />
                  <Route path="/test-suites/:suiteId" element={<DefinitionTestSuiteReport />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="/definitions" element={<MarketplaceDefinitions />} />
                  <Route path="/definitions/new" element={<DefinitionEditor />} />
                  <Route path="/definitions/:id/edit" element={<DefinitionEditor />} />
                  <Route path="/status" element={<SystemStatus />} />
                  <Route path="/issues" element={<Issues />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </Box>
  );
}

export default App;
